<div class="wrapper" [ngClass]="{ 'four-items': fourItems,'five-items':fiveItems, 'six-items':sixItems}">
    <!-- <pdp-item-two  [ngClass]="{'active': isFeatured && i < 6,'carousel-item ': isFeatured}"  *ngFor="let responseItem of content,let i=index;" 
                            [product]="responseItem" 
                            [category]="category"
                            [isFeatured]="isFeatured">
    </pdp-item-two> -->

    <pdp-product-box *ngFor="let responseItem of content,let i=index;" [company]="company" [product]="responseItem" [index]="i" class="product-box product-box-list"></pdp-product-box>

    <!-- <pdp-product-list-item  [ngClass]="{'active': isFeatured && i < 6,'carousel-item ': isFeatured}"  *ngFor="let responseItem of content,let i=index;" 
                            [company]="company"
                            [product]="responseItem" 
                            [category]="category"
                            [isFeatured]="isFeatured">
    </pdp-product-list-item> -->
</div>